import React, { useState } from 'react'
import { DialogSpin } from 'components'
import { Button } from '@mui/material'
import { useUpdateProceedingMutation, successSnack, errorSnack } from 'features'
import { useDispatch } from 'react-redux'
import { useParams } from 'react-router-dom'

export default function DeleteStudentProceedingsDialog(_props) {
  const {
    togglerComponent: Component = { Button },
    children,
    togglerProps = {},
    studentProceeding = null,
    successCallback = null,
    errorCallback = null,
  } = _props
  const { proceedingId } = useParams()
  const [open, setOpen] = useState(false)

  const dispatch = useDispatch()

  function openDialog(e) {
    e.stopPropagation()
    setOpen(true)
  }
  function closeDialog() {
    setOpen(false)
  }

  const [updateProceeding] = useUpdateProceedingMutation()

  async function handleSubmit() {
    try {
      const result = await updateProceeding({
        proceedingid: proceedingId,
        studentdni: studentProceeding,
      })

      if (result?.data?.message === 'proceeding_update') {
        dispatch(
          successSnack({
            message: `Estudiante ${studentProceeding} eliminado del lote`,
          })
        )
        closeDialog()
      } else {
        dispatch(
          errorSnack({
            message: 'Error al eliminar estudiante del lote',
          })
        )
        closeDialog()
      }
    } catch (error) {
      console.log(error)
      if (errorCallback) errorCallback()
      dispatch(errorSnack({ message: 'Error para eliminadar el lote' }))
      closeDialog()
    }
  }

  return (
    <>
      <Component onClick={openDialog} {...togglerProps}>
        {children}
      </Component>
      {open && (
        <DialogSpin
          open={open}
          handleClose={closeDialog}
          primaryButtonText="Si, eliminar" //Label of the primary button
          secondaryButtonText="Cancelar" // Label of the cancel button
          title={'Eliminar estudiante del lote'} // 'Dialog title'
          message={`¿Estás seguro de eliminar el estudiante ${studentProceeding} 'del lote
          \nEste paso no se puede deshacer.`}
          onSubmit={handleSubmit} // Form submit action
        ></DialogSpin>
      )}
    </>
  )
}
